








import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';

import Plotly from 'src/misc/external/plotly';


@Component
export default class FoodSafetyPlotWrapperObject extends Vue {
  $refs: {
    plotRef: HTMLElement
  }

  get project() {
    return this.$store.state.currentProject
  }

  get boards() {
    return this.$store.state.currentProject.boards;
  }

  get appMenuMini() {
    return this.$store.state.appMenuMini;
  }

  get card() {
    return this.$store.getters.getCard('GraphsCard');
  }

  get lgAndUp() {
    return this.$vuetify.breakpoint.lgAndUp;
  }

  @Watch('boards', { deep: true })
  onBoardsChanged() {
    Plotly.purge(this.$refs.plotRef);
    this.redrawPlots();
  }

  @Watch('appMenuMini')
  onAppMenuMiniChanged() {
    this.handleResizeDelayed();
  }

  @Watch('card', { deep: true })
  onCardChanged() {
    this.handleResizeDelayed();
  }

  @Watch('lgAndUp')
  onLgAndUpChanged() {
    this.handleResize();
  }

  mounted() {
    this.redrawPlots();
    window.addEventListener('resize', this.handleResize);

    this.handleResizeDelayed();
  }

  redrawPlots() {
    let marginScale = Math.min(1.0, Math.max(0.0, this.$refs.plotRef.getBoundingClientRect().width - 520) / 330);

    var compareValueLabel = 'food_contact_risk';

    var compareSublabels = ['Food Type', 'Packaging', 'Storage'];
    var compareSublabelX = 1.3 - 0.160 * marginScale;
    var compareSublabelY = [1.05, 0.90, 0.75];
    var compareSublabelValues = [
      this.project.food_type         != null ? this.project.food_type.name         : 'Loading...',
      this.project.packaging_system  != null ? this.project.packaging_system.name  : 'Loading...',
      this.project.storage_condition != null ? this.project.storage_condition.name : 'Loading...',
    ];

    var compareValueFormat = '.2f';
    var theme: any = this.$vuetify.theme;

    var themeColors = [
      theme.boardColor1,
      theme.boardColor2,
      theme.boardColor3,
      theme.boardColor4,
      theme.boardColor5,
      theme.boardColor6,
      theme.boardColor7,
      theme.boardColor1,
      theme.boardColor2,
      theme.boardColor3,
      theme.boardColor4,
      theme.boardColor5,
      theme.boardColor6,
      theme.boardColor7
    ]

    var data = [];

    var layout = {
      margin: {
        t: 80,
        b: 40,
        l: 110 + 40.0 * marginScale,
        r: 150 + 40.0 * marginScale,
      },
      title: 'Food Safety',
      showlegend: false
    }
    layout['annotations'] = [];
    layout['shapes'] = [];

    let maxValue = 2.0;

    layout['shapes'].push(
    {
      type: 'line',
      xref: 'x',
      yref: 'y',
      x0: 0.5,
      x1: 1.5,
      y0: 2.0,
      y1: 2.0,
      opacity: 0.0,
      line: {
        width: 3,
        color: 'black',
      },
    });

    for (let j = 0; j < this.boards.length; j++) {
      let board = this.boards[j];

      if (!board.visible ||
          !board.hasBoardResults() ||
          board.hasSimulationErrors() ||
          !board.hasSimulationSuccessWithCarbonFootprint())
        continue;

      var trace = {
        x: [ 1 ],
        y: [ board.simulationResults[0][compareValueLabel] ],
        xaxis: 'x',
        yaxis: 'y',
        marker:{
          color: [ themeColors[j] ],
        },
        hoverinfo:"y",
        type: 'bar',
        name: board.name,
      };

      data.push(trace);

      maxValue = Math.max(board.simulationResults[0][compareValueLabel], maxValue);
    }

    maxValue = Math.ceil(maxValue);

    for (let x = maxValue - 0.05; x > .95; x = x - 0.05) {
      x = Math.round(x * 10000) / 10000;
      layout['shapes'].push(
      {
        type: 'rect',
        xref: 'x',
        yref: 'y',
        x0: 0.5,
        x1: 0.515,
        y0: x + 0.05,
        y1: x - 0.00,
        fillcolor: theme.info,
        opacity: x * 0.6 - 0.3,
        line: {
          width: 0,
          color: 'red',
        },
      });
    }

    layout['shapes'].push(
    {
      type: 'line',
      xref: 'x',
      yref: 'y',
      x0: 0.5,
      x1: 1.5,
      y0: 1.0,
      y1: 1.0,
      opacity: 0.3,
      line: {
        width: 2,
        color: 'black',
      },
    });

    for (let x = 0.05; x < 1.05; x = x + 0.05) {
      layout['shapes'].push(
      {
        type: 'rect',
        xref: 'x',
        yref: 'y',
        x0: 0.5,
        x1: 0.515,
        y0: x + 0.00,
        y1: x - 0.05,
        fillcolor: theme.error,
        opacity: 0.7 - x * 0.6,
        line: {
          width: 0,
          color: 'red',
        },
      });
    }

    layout['annotations'].push({
      xref: 'paper',
      yref: 'y',
      x: -0.06,
      xanchor: 'right',
      y: maxValue,
      yanchor: 'center',
      text: 'Low Risk',
      font: {
        size: 12,
      },
      showarrow: false,
    });

    layout['annotations'].push({
      xref: 'paper',
      yref: 'y',
      x: -0.06,
      xanchor: 'right',
      y: 1.0,
      yanchor: 'center',
      text: 'Neutral',
      font: {
        size: 12,
      },
      showarrow: false,
    });

    layout['annotations'].push({
      xref: 'paper',
      yref: 'y',
      x: -0.06,
      xanchor: 'right',
      y: 0.0,
      yanchor: 'center',
      text: 'High Risk',
      font: {
        size: 12,
      },
      showarrow: false,
    });

    layout['yaxis'] = {
      hoverformat: compareValueFormat,
      fixedrange: true,
      anchor: 'x',
    };

    layout['xaxis'] = {
      fixedrange: true,
      showticklabels: false,
    };

    for (let j = 0; j < compareSublabels.length; j++) {
      layout['annotations'].push({
        xref: 'paper',
        yref: 'paper',
        x: compareSublabelX,
        xanchor: 'center',
        y: compareSublabelY[j],
        yanchor: 'bottom',
        text: compareSublabels[j],
        opacity: 0.4,
        font: {
          size: 12,
          color: 'black',
        },
        showarrow: false,
      });

      layout['annotations'].push({
        xref: 'paper',
        yref: 'paper',
        x: compareSublabelX,
        xanchor: 'center',
        y: compareSublabelY[j] - 0.05,
        yanchor: 'bottom',
        text: compareSublabelValues[j],
        font: {
          size: 12,
        },
        showarrow: false,
      });
    }

    var config = {
      displayModeBar: false
    };

    Plotly.plot( this.$refs.plotRef, data, layout, config);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResizeDelayed() {
    setTimeout(() => {
      this.handleResize();
    }, 200);
  }

  handleResize() {
    Plotly.purge(this.$refs.plotRef);
    this.redrawPlots();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FoodSafetyPlotWrapperObject.vue